var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "dx-load-panel",
    _vm._b(
      {
        staticClass: "loading-panel-container",
        attrs: {
          position: _vm.position,
          visible: _vm.isLoading,
          "show-indicator": _vm.showIndicator,
          "show-pane": _vm.showPane,
          shading: _vm.shading,
          "shading-color": "rgba(0,0,0,0.4)",
          "indicator-src": _vm.indicatorSrc,
          width: "350",
          height: "200"
        },
        on: {
          "update:visible": function($event) {
            _vm.isLoading = $event
          }
        }
      },
      "dx-load-panel",
      _vm.customProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }